var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.noHorizontalPadding ? 'div' : 'padded-content',{tag:"component",staticClass:"column-header",class:{
		'top-header': _vm.isTopHeader,
		'space-children-inline-loose column-header--large': _vm.size === _vm.Size.LARGE,
		'space-children-inline-wide column-header--medium': _vm.size === _vm.Size.MEDIUM,
		'space-children-inline-regular column-header--small': _vm.size === _vm.Size.SMALL,
	}},[_c(_vm.headerTag,{tag:"component",staticClass:"space-children-inline-regular",class:{
			'header-large': _vm.size === _vm.Size.LARGE,
			'header-medium': _vm.size === _vm.Size.MEDIUM,
			'header-small': _vm.size === _vm.Size.SMALL,
		}},[_vm._t("default")],2),(_vm.backTo)?_c('router-link',{attrs:{"to":_vm.backTo},scopedSlots:_vm._u([{key:"default",fn:function(ref){
		var href = ref.href;
		var navigate = ref.navigate;
return [_c('back-button',{staticClass:"back-button",attrs:{"tag":"a","href":href},on:{"click":navigate}},[_vm._t("backContent",[_vm._v(" "+_vm._s(_vm.backLabel)+" ")])],2)]}}],null,true)}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }